import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const NotificationPreferences = () => {
  const [preferences, setPreferences] = useState({
    emailNotifications: {
      newDiscounts: true,
      membershipExpiry: true,
      promotions: false,
      newsletter: true
    },
    smsNotifications: {
      urgentAlerts: true,
      discountReminders: false
    },
    pushNotifications: {
      nearbyDeals: true,
      rewardUpdates: true
    }
  });

  const handleToggle = (category, key) => {
    setPreferences(prev => ({
      ...prev,
      [category]: {
        ...prev?.[category],
        [key]: !prev?.[category]?.[key]
      }
    }));
  };

  const handleSave = () => {
    // Implement save logic
    alert('Preferencias de notificación actualizadas');
  };

  return (
    <div className="space-y-6">
      {/* Email Notifications */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <Icon name="Mail" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Notificaciones por Correo</h2>
            <p className="text-sm text-muted-foreground">Gestiona tus preferencias de email</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Nuevos Descuentos</p>
              <p className="text-xs text-muted-foreground">Recibe alertas de descuentos en negocios cercanos</p>
            </div>
            <Checkbox
              checked={preferences?.emailNotifications?.newDiscounts}
              onChange={() => handleToggle('emailNotifications', 'newDiscounts')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Vencimiento de Membresía</p>
              <p className="text-xs text-muted-foreground">Recordatorios antes de que expire tu plan</p>
            </div>
            <Checkbox
              checked={preferences?.emailNotifications?.membershipExpiry}
              onChange={() => handleToggle('emailNotifications', 'membershipExpiry')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Promociones</p>
              <p className="text-xs text-muted-foreground">Ofertas especiales y promociones exclusivas</p>
            </div>
            <Checkbox
              checked={preferences?.emailNotifications?.promotions}
              onChange={() => handleToggle('emailNotifications', 'promotions')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Boletín Informativo</p>
              <p className="text-xs text-muted-foreground">Noticias y actualizaciones de Bizznet</p>
            </div>
            <Checkbox
              checked={preferences?.emailNotifications?.newsletter}
              onChange={() => handleToggle('emailNotifications', 'newsletter')}
            />
          </div>
        </div>
      </div>

      {/* SMS Notifications */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
            <Icon name="MessageSquare" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Notificaciones por SMS</h2>
            <p className="text-sm text-muted-foreground">Alertas importantes por mensaje de texto</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Alertas Urgentes</p>
              <p className="text-xs text-muted-foreground">Notificaciones críticas de cuenta</p>
            </div>
            <Checkbox
              checked={preferences?.smsNotifications?.urgentAlerts}
              onChange={() => handleToggle('smsNotifications', 'urgentAlerts')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Recordatorios de Descuentos</p>
              <p className="text-xs text-muted-foreground">Ofertas limitadas por tiempo</p>
            </div>
            <Checkbox
              checked={preferences?.smsNotifications?.discountReminders}
              onChange={() => handleToggle('smsNotifications', 'discountReminders')}
            />
          </div>
        </div>
      </div>

      {/* Push Notifications */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-success/10">
            <Icon name="Bell" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Notificaciones Push</h2>
            <p className="text-sm text-muted-foreground">Alertas en tiempo real en tu dispositivo</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Ofertas Cercanas</p>
              <p className="text-xs text-muted-foreground">Descuentos en negocios cerca de tu ubicación</p>
            </div>
            <Checkbox
              checked={preferences?.pushNotifications?.nearbyDeals}
              onChange={() => handleToggle('pushNotifications', 'nearbyDeals')}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground">Actualizaciones de Rewards</p>
              <p className="text-xs text-muted-foreground">Cambios en tus puntos y comisiones</p>
            </div>
            <Checkbox
              checked={preferences?.pushNotifications?.rewardUpdates}
              onChange={() => handleToggle('pushNotifications', 'rewardUpdates')}
            />
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-card">
        <Button
          variant="default"
          fullWidth
          onClick={handleSave}
          iconName="Save"
          iconPosition="left"
        >
          Guardar Preferencias
        </Button>
      </div>
    </div>
  );
};

export default NotificationPreferences;